import React, { Component } from 'react';
import { AcceptButton } from '../components/Button';
import _ from 'lodash'

import SchoolTable from './components/SchoolTable';
import schoolStore from './stores/SchoolStore';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

class ProductReportList extends Component {
  constructor(props) {
    super(props);
    this.onChangeTextDebounce = _.debounce(this.onChangeTextDebounce.bind(this), 600);
  }
  onCreateClick = () => {
    schoolStore.setShowModal(true);
  }

  async onChangeTextDebounce() {
    const { getSchoolCount, setTableCurrentPage, getSchoolList } = schoolStore;
    await getSchoolCount();
    setTableCurrentPage(1);
    getSchoolList();
  }

  onChangeText = async (e) => {
    const { onTextSearchChange } = schoolStore;
    onTextSearchChange(e.target.value);
    this.onChangeTextDebounce();
  }
  render() {
    const { txtSearch } = toJS(schoolStore);
    console.log(txtSearch)
    return (
      <div className="card">
        <div className="card-body">
          <div className='row justify-content-end' style={{ margin: 0, flex: 1, paddingRight: 16 }}>
            <AcceptButton onClick={this.onCreateClick} containerStyle={{ height: 'fit-content' }} title='Tạo mới' />
          </div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className='material-icons'>search</i>
              </span>
            </div>
            <input
              style={{ marginBottom: 12 }}
              onChange={this.onChangeText}
              type="text"
              value={txtSearch}
              className="form-control"
              placeholder="Tìm kiếm theo tên trường hoặc tên viết tắt..." />
          </div>
          <SchoolTable />
        </div>
      </div>
    )
  }

  componentDidMount() {
    schoolStore.getSchoolList();
    schoolStore.getSchoolCount();
  }
}

export default observer(ProductReportList)